import React from "react";

const ShareIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg viewBox="0 0 66 66" fill="none" {...props}>
    <g filter="url(#filter0_d_10402_5202)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20.6867C10 14.4428 14.436 10 20.669 10H45.0534C51.2869 10 55.7224 14.4433 55.7224 20.6867V45.8746C55.7224 51.3551 51.2864 55.798 45.8154 55.798H19.907C14.4355 55.798 10 51.3546 10 45.8746V20.6867Z"
        fill="url(#paint0_linear_10402_5202)"
      />
    </g>
    <g clipPath="url(#clip0_10402_5202)">
      <path
        d="M30.0646 22.8009C30.1627 21.774 31.2348 20.928 32.3159 21.5454C34.5634 22.8616 36.6844 24.3612 38.7355 25.9642C41.2672 27.9637 43.299 29.8482 44.7379 31.353C45.3618 32.0079 45.3037 33.0425 44.7069 33.6677C43.282 35.1416 41.7748 36.5336 40.1925 37.8372C37.6893 39.8871 35.0969 41.8737 32.2746 43.4663C31.3175 44.0062 30.2803 43.3888 30.0956 42.4317L30.0736 42.2857L29.7804 37.6693C27.4347 37.7184 25.164 38.5244 23.3479 40.024L23.0056 40.3107L22.8403 40.4451L22.5212 40.6931C22.4696 40.7318 22.4179 40.7706 22.3662 40.8067L22.0692 41.0134C21.9769 41.0741 21.883 41.1322 21.7876 41.1878L21.5215 41.3312C20.2737 41.9473 19.584 41.4022 19.584 38.9584C19.584 33.2699 23.7754 28.2078 29.442 27.4406L29.7765 27.4005L30.0646 22.8009ZM32.5304 24.7048L32.2824 29.1895C32.274 29.3428 32.2113 29.4881 32.1055 29.5994C31.9997 29.7106 31.8577 29.7805 31.705 29.7966L29.947 29.98C25.9881 30.4527 22.8467 33.5476 22.2642 37.5931C24.2004 36.1654 26.4985 35.3098 28.8969 35.1234L29.4097 35.0937L31.6107 35.0472C31.7781 35.0436 31.9404 35.1051 32.0633 35.2189C32.1862 35.3326 32.2601 35.4897 32.2694 35.6569L32.5239 40.3017C34.5944 38.9829 36.5681 37.4652 38.5482 35.8454C39.8271 34.783 41.0584 33.6646 42.2385 32.4936L41.9053 32.1629L41.1871 31.4744C39.8881 30.2576 38.5375 29.097 37.139 27.996C35.6558 26.8266 34.1178 25.7283 32.5304 24.7048Z"
        fill="#8065C9"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_10402_5202"
        x="0"
        y="0"
        width="65.7227"
        height="65.7979"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10402_5202"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10402_5202"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10402_5202"
        x1="10"
        y1="10"
        x2="10"
        y2="55.798"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#E8E8E8" />
      </linearGradient>
      <clipPath id="clip0_10402_5202">
        <rect
          width="31"
          height="31"
          fill="white"
          transform="translate(17 17)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ShareIcon;
